import { I18nProvider } from '../providers/I18nProvider';
import { Calculator } from './Calculator';

interface AppProps {
  currency?: string;
  currencyOptions?: string;
  amount?: string;
  focusAmount?: boolean;
  period?: string;
  locale?: string;
}

export function App(props: AppProps) {
  return (
    <I18nProvider locale={props.locale}>
      <Calculator
        currency={props.currency}
        currencyOptions={props.currencyOptions}
        amount={props.amount}
        focusAmount={props.focusAmount}
        period={props.period}
      />
    </I18nProvider>
  );
}
